<template>
  <ul class="my-0 list-unstyled">
    <matches v-if="!isEmpty(matches)"
      :matches="matches"
      view="popover"
    />

    <li v-if="description" class="row-content row-content_text">
      <span
        class="row-content--main"
        v-html="description"
        v-line-clamp="4"
      />
    </li>

    <partial-owners v-if="!isEmpty(data.owners)"
      :owners="owners"
      :highlights="highlightResearchers"
      :highlightKeys="['researchers.full_name.normalized', 'researchers.initial_name.normalized']"
      :renderWithLinkTo="false"
      :isText="true"
      :containerClass="`mt-2 row-content_text`"
      :lineClamp="3">
    </partial-owners>

    <partial-publication-count v-if="data.publications_count"
      :countPublications="data.publications_count"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-publication-count>

    <partial-project-count v-if="data.projects_count"
      :countProjects="data.projects_count"
      :isText="true"
      :containerClass="`mt-2 row-content_text`">
    </partial-project-count>
  </ul>
</template>

<script>
import processing from '@/mixins/search/results/researchGroup'

import Matches from '@/components/search/results/partials/Matches'
import PartialOwners from '@/components/search/results/partials/Owners'
import PartialPublicationCount from '@/components/search/results/partials/PublicationCount'
import PartialProjectCount from '@/components/search/results/partials/ProjectCount'

export default {
  name: 'researchGroupResultPopover',
  mixins: [processing],
  components: {
    Matches,
    PartialOwners,
    PartialProjectCount,
    PartialPublicationCount
  },
  mounted () {
    if (
      !this.isEmpty(this.matches) ||
      this.description ||
      !this.isEmpty(this.data.owners) ||
      this.data.publications_count ||
      this.data.projects_count
    ) {
      this.$emit('setIsEmptyPopover', false)
    } else {
      this.$emit('setIsEmptyPopover', true)
    }
  }
}
</script>
